import { supabase } from '../supabase';
import { createSupabaseAuthClient } from './supabase-auth-client';

export type { AuthClient, AuthEvent, AuthSession, OAuthProvider } from './auth-client';
export { AuthError } from './auth-client';

export const auth = createSupabaseAuthClient(supabase.auth);
